import { useQuery } from '@tanstack/react-query';
import V1InstanceApi from '@Apis/V1/instance';
import type { SolutionTrialEligibilityResponse } from '@Types/credit';

/**
 * App Code for Cloud Email and Collaboration Protection
 */
const EMAIL_COLLABORATION_APP_CODE = 'V1_EMAILSECURITY';

/**
 * Custom hook to check solution trial eligibility
 *
 * @returns Query result with eligibility data and loading/error states
 */
export const useSolutionTrialEligibility = () => {
  return useQuery<SolutionTrialEligibilityResponse>({
    queryKey: ['solutionTrialEligibility', EMAIL_COLLABORATION_APP_CODE],
    queryFn: async () => {
      const response = await V1InstanceApi.getSolutionTrialEligibilityStatus(
        EMAIL_COLLABORATION_APP_CODE
      );
      return response;
    },
    // Cache for 5 minutes
    staleTime: 5 * 60 * 1000,
    // Retry once on failure
    retry: 1,
    // Don't refetch on window focus to avoid unnecessary API calls
    refetchOnWindowFocus: false,
  });
};
